export { default } from './LinkCopier';
